import gql from 'graphql-tag';

export const quickQuote = gql`
  query quickQuote($payLoad: JSON!) {
    quickQuote(payLoad: $payLoad) {
      leaseTerm
      kmsPerYear
      costs {
        fuel
        maintenance
        tyres
        registration
        insurance
      }
      novated {
        salarySacrificePayment
        notSalarySacrificePayment
        novatedSaving
        totalTaxSaving
        taxSaving
        gstSavingBudget
        gstSavingVehicle
        salarySacrificeTakeHomePay
        notSalarySacrificeTakeHomePay
        salarySacrificeImpactTakeHome
        notSalarySacrificeImpactTakeHome
      }
      calculation {
        label
        information
        sacrifice
        noSacrifice
        negative
        bold
      }
      takeHome {
        sacrifice
        noSacrifice
      }
    }
  }
`;

export const getQuote = gql`
  query getQuote($quoteId: String!) {
    getQuote(quoteId: $quoteId) {
      quoteId
      erpQuoteRef
      milesQuoteRef
      quoteRevisionNumber
      status
      make {
        id
        name
        description
      }
      bodyType
      model {
        id
        name
      }
      variant {
        id
        name
        gears
        induction
        driveType
        power
        torque
        greenStarRating
        ancapRating
        modelYear
        external_code
        listPriceNet
        listPriceGst
        listPriceGross
        derivativeId
        derivative
        fuelTypeId
        fuelType
        engineSize
        engineCylinders
        engineDescription
        co2Emissions
        grossUnloadedWeight
        grossLoadedWeight
        grossTowedWeight
        fuelConsumption
        fuelConsumptionHighway
        fuelConsumptionCombined
        trimId
        trim
        transmissionId
        transmission
        transmissionGroupId
        doors
        seats
        serviceGroup
        length
        height
        fuelTankCapacity
        octaneRating
        warrantyMonths
        warrantyKms
        bodyTypeId
        photos {
          type
          path
        }
      }
      leaseTerm
      kmsPerYear
      leaseStart
      leaseEnd
      exteriorColour {
        name
      }
      interiorColour {
        name
      }
      includedEquipment {
        id
        code
        name
        amountNet
        amountGst
        amountGross
      }
      optionalEquipment {
        id
        code
        name
        amountNet
        amountGst
        amountGross
      }
      customer {
        companyName
        companyAbn
        customerName
        customerContactNumber
        deliveryAddressLine1
        deliveryAddressLine2
        deliverySuburb
        deliveryState
        deliveryPostcode
        deliveryDate
        dealership
        registrationPostcode
      }
      price {
        onRoadCost
        fbtValue
        listPrice
        listPriceNet
        listPriceGst
        listPriceGross
        monthlyRentalNet
        monthlyRentalGst
        monthlyRentalGross
        weeklyRentalNet
      }
      novated {
        budgets {
          type
          cost
          disclaimer
        }
        additionalInsurances {
          type
          cost
        }
        fees {
          type
          cost
        }
        grossSalary
        preTaxDeduction
        netTaxableIncome
        incomeTax
        postTaxDeduction
        fbtTaxExemption
        netIncome
        taxSaving
        gstSavingBudget
        gstSavingVehicle
        impactTakeHome
        residualValue
      }
      insuranceProvider
    }
  }
`;

export const saveQuote = gql`
  mutation saveQuote($payLoad: JSON!) {
    saveQuote(payLoad: $payLoad) {
      quoteId
      erpQuoteRef
      status
      make {
        id
        name
        description
      }
      bodyType
      model {
        id
        name
      }
      variant {
        id
        name
        gears
        induction
        driveType
        power
        torque
        greenStarRating
        ancapRating
        modelYear
        external_code
        listPriceNet
        listPriceGst
        listPriceGross
        derivativeId
        derivative
        fuelTypeId
        fuelType
        engineSize
        engineCylinders
        engineDescription
        co2Emissions
        grossUnloadedWeight
        grossLoadedWeight
        grossTowedWeight
        fuelConsumption
        fuelConsumptionHighway
        fuelConsumptionCombined
        trimId
        trim
        transmissionId
        transmission
        transmissionGroupId
        doors
        seats
        serviceGroup
        length
        height
        fuelTankCapacity
        octaneRating
        warrantyMonths
        warrantyKms
        bodyTypeId
        photos {
          type
          path
        }
      }
      leaseTerm
      kmsPerYear
      leaseStart
      leaseEnd
      exteriorColour {
        name
      }
      interiorColour {
        name
      }
      includedEquipment {
        id
        code
        name
        amountNet
        amountGst
        amountGross
      }
      optionalEquipment {
        id
        code
        name
        amountNet
        amountGst
        amountGross
      }
      customer {
        companyName
        companyAbn
        customerName
        customerContactNumber
        deliveryAddressLine1
        deliveryAddressLine2
        deliverySuburb
        deliveryState
        deliveryPostcode
        deliveryDate
        dealership
        registrationPostcode
      }
      price {
        onRoadCost
        fbtValue
        listPrice
        listPriceNet
        listPriceGst
        listPriceGross
        monthlyRentalNet
        monthlyRentalGst
        monthlyRentalGross
        weeklyRentalNet
      }
      novated {
        budgets {
          type
          cost
        }
        fees {
          type
          cost
        }
        grossSalary
        preTaxDeduction
        netTaxableIncome
        incomeTax
        postTaxDeduction
        netIncome
        taxSaving
        gstSavingBudget
        gstSavingVehicle
        impactTakeHome
        residualValue
      }
      insuranceProvider
    }
  }
`;
export const acceptQuoteMutation = gql`
  mutation acceptCurrentQuote($payLoad: AcceptQuotePayload!) {
    acceptCurrentQuote(payLoad: $payLoad) {
      quoteId
      status
    }
  }
`;

export const getVariantOptions = gql`
  query getVariantOptions($variantId: String!) {
    getVariantOptions(variantId: $variantId) {
      exteriorColours
      interiorColours
      includedEquipment
      optionalEquipment
    }
  }
`;

export const getQuotePDF = gql`
  query getQuotePdf($quoteId: String!) {
    getQuotePdf(quoteId: $quoteId) {
      signedUrl
    }
  }
`;
